import { sessionFetch } from '../../../utils/sessionFetch';
import { getAuthToken } from '../../../utils/login';
import { getServerEndpoint, getSubdomain } from '../../../utils/utils';

async function request(path, options = {}) {
    const token = getAuthToken();
    if (!token) throw new Error('Torna a iniciar sessió per crear una plantilla amb IA.');
    const response = await sessionFetch(`${getServerEndpoint(getSubdomain())}/api/plantilles/ai${path}`, {
        ...options,
        headers: { Authorization: `Bearer ${token}` },
        cache: 'no-store',
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || 'No s’ha pogut contactar amb el servei d’IA. Torna-ho a provar.');
    return data;
}

export const getAiConfig = signal => request('/config', { signal });
export const startAiGeneration = file => {
    const body = new FormData();
    body.append('image', file);
    return request('/jobs', { method: 'POST', body });
};
export const getAiGeneration = (id, signal) => request(`/jobs/${encodeURIComponent(id)}`, { signal });
export const cancelAiGeneration = id => request(`/jobs/${encodeURIComponent(id)}`, { method: 'DELETE' });

export const templateFileName = name => name.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    .replace(/\.[^.]+$/, '').replace(/[^a-zA-Z0-9_()-]+/g, '-').replace(/^-+|-+$/g, '').toLowerCase() || 'croquis';
